import { useMemo } from "react";
import { useLocale } from "../contexts/LocaleContext";
import "./styles/video.css";

// "Wie funktioniert es?" — five numbered steps describing how a user picks
// a frame and uploads art. Visual layout identical to the legacy video.html.
export function VideoPage() {
  const { t } = useLocale();

  const steps = useMemo(
    () => [
      <>{t("video.step1")}</>,
      <>{t("video.step2")}</>,
      <>{t("video.step3")}</>,
      <>{t("video.step4")}</>,
      <>
        {t("video.step5")}{" "}
        <a href="https://www.mage.space" target="_blank" rel="noreferrer">
          www.mage.space
        </a>
        {t("video.step5Suffix")}
      </>,
    ],
    [t],
  );

  return (
    <section className="how-it-works">
      <h1>{t("video.title")}</h1>
      <div className="video-embed">
        <iframe
          src={t("video.youtubeEmbedUrl")}
          title={t("video.title")}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
      {steps.map((content, i) => (
        <div className="step" key={i}>
          <div className="step-visual" aria-hidden="true">
            <img
              src={`/static/img/steps/${i + 1}.png`}
              alt=""
              loading="lazy"
            />
          </div>
          <div className="step-content">{content}</div>
        </div>
      ))}
    </section>
  );
}
